import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFullPageDispatch } from '../contexts/FullPageContext';

export default function FullPageController() {
  const { pathname } = useLocation();
  const fullPageDispatch = useFullPageDispatch();

  useLayoutEffect(() => {
    const pathArray = pathname.split('/');
    let isMarketplacePreview;
    let isDashboardEditor;

    if (pathArray.length >= 3) {
      isMarketplacePreview =
        pathArray[1].toLowerCase() === 'marketplace' &&
        pathArray[3]?.toLowerCase() === 'dashboard';
      isDashboardEditor =
        pathArray[1].toLowerCase() === 'workspace' &&
        pathArray[pathArray.length - 1].toLowerCase() === 'edit';
    }

    // use the pathArray to dispatch full page true if we should be in full page or false if we should not be
    // ** IMPORTANT- Remove full page dispatches from any other component that is doing it so that it is controlled only from here **
    // ...k
    if (isMarketplacePreview || isDashboardEditor) {
      fullPageDispatch({ type: 'setFullPage', payload: true });
    } else {
      fullPageDispatch({ type: 'setFullPage', payload: false });
    }
  }, [pathname, fullPageDispatch]);

  return null;
}
